import { render } from "./Team.html?vue&type=template&id=20676813&scoped=true&ts=true&external"
import script from "./Team.ts?vue&type=script&lang=ts&external"
export * from "./Team.ts?vue&type=script&lang=ts&external"

import "./Team.scss?vue&type=style&index=0&id=20676813&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20676813"]])

export default __exports__